"use client";

import Image from "next/image";
import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

const images = [
  {
    src: "https://res.cloudinary.com/dkaghqnvm/image/upload/v1736333450/Trichos/3_gqtem4.jpg",
    alt: "Best Hair Transplant Award",
  },
  {
    src: "https://res.cloudinary.com/dkaghqnvm/image/upload/v1736333449/Trichos/1_n6dimt.jpg",
    alt: "Dr John Watts Youtube Video",
  },
  {
    src: "https://res.cloudinary.com/dkaghqnvm/image/upload/v1736333449/Trichos/2_ndva0m.jpg",
    alt: "Best Hair Transplant Award",
  },
];

export default function PhotoSliderPhoto() {
  return (
    <div className="relative w-full">
      <Carousel
        autoPlay
        infiniteLoop
        interval={5000}
        showStatus={false}
        showThumbs={false}
        showIndicators={true}
        showArrows={true}
        className="w-full"
      >
        {images.map((image, index) => (
          <div key={index} className="relative aspect-video w-full">
            <Image
              src={image.src}
              alt={image.alt}
              fill
              priority={index === 0}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
}
